module.exports = __webpack_public_path__ + "static/fonts/themify.e23a7dc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/themify.ttf?-fvbane
// module id = 471
// module chunks = 0 1 2 3 4